import { render, staticRenderFns } from "./SemenInfoTables.vue?vue&type=template&id=28d55e64&scoped=true&"
import script from "./SemenInfoTables.vue?vue&type=script&lang=js&"
export * from "./SemenInfoTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d55e64",
  null
  
)

export default component.exports